import { BmHttp } from "../utils/Global";

// ANULACION-FISCAL-64 -- Reporte de Documentos Anulados.
// Analítico / 100% solo lectura: no anula, no revierte, no toca secuencias --
// únicamente consulta lo que la anulación ya dejó escrito.

const buildParams = ({ page, limit, filters = {} }) => ({
    page,
    limit,
    fecha_inicial: filters.fecha_inicial,
    fecha_final: filters.fecha_final,
    campo_fecha: filters.campo_fecha,
    idclinica: filters.idclinica,
    documento: filters.documento,
    num_documento: filters.num_documento,
    fiscal: filters.fiscal,
    secuencial: filters.secuencial,
});

export const GetDocumentosAnulados = async ({ page = 1, limit = 20, filters }) => {
    try {
        const { data } = await BmHttp().get(`reporte/documentos-anulados`, { params: buildParams({ page, limit, filters }) });
        return data;
    } catch (error) {
        return error.response?.data || { success: false, data: [], message: "Error de red" };
    }
};

export const GetDocumentosAnuladosExcel = async ({ filters }) => {
    return BmHttp().get(`reporte/documentos-anulados/excel`, {
        params: buildParams({ filters }),
        responseType: "blob",
    });
};

export const GetDocumentosAnuladosPdf = async ({ filters }) => {
    return BmHttp().get(`reporte/documentos-anulados/pdf`, {
        params: buildParams({ filters }),
        responseType: "blob",
    });
};
